import { START_TOAST, CLEAR_TOAST } from '../actions/toast';

export default function Toast(state = { open: false }, action) {
  switch (action.type) {
    case START_TOAST:
      return {
        ...state,
        action: action.action,
        message: action.message || (action.error || {}).message,
        onActionClick: action.onActionClick,
        open: true,
        error: action.error,
        autoHideDuration: action.autoHideDuration
      };
    case CLEAR_TOAST:
      return {
        ...state,
        open: false
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/toast.js